<div class="audience-scope">
  <div class="audience-scope__field">
    <label class="audience-scope__label">
      {{ labelKey | translate }}
    </label>
    <ui-form-field
      type="select"
      [formControl]="audienceControl"
      [placeholder]="'knowledge_base.upload.select_audience' | translate"
      [fullWidth]="true"
      [options]="translatedOptions"
    ></ui-form-field>
    <p class="audience-scope__hint" *ngIf="hintKey">{{ hintKey | translate }}</p>
  </div>

  <!-- Customers, several of them — the same chips the knowledge base's own
       upload offers, and the same the groups below use. A host looking at a
       single price row passes maxCustomers=1 and gets one chip. The list is
       proposed before anything is typed; typing narrows it server-side. -->
  <div class="audience-scope__field" *ngIf="isCustomer">
    <label class="audience-scope__label" for="audience-customer">
      {{ "knowledge_base.upload.select_company" | translate }}
    </label>
    <mat-chip-list #customerChipList>
      <mat-chip
        *ngFor="let customer of selectedCustomers"
        [removable]="true"
        (removed)="removeCustomer(customer)"
        class="audience-scope__chip"
      >
        {{ customer.name }}
        <ui-svg-icon svgIcon="close-cc" size="small" matChipRemove></ui-svg-icon>
      </mat-chip>
      <input
        *ngIf="!customerLimitReached"
        id="audience-customer"
        [formControl]="customerControl"
        [matAutocomplete]="customerAuto"
        [matChipInputFor]="customerChipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="false"
        [placeholder]="'knowledge_base.upload.select_company_placeholder' | translate"
      />
    </mat-chip-list>
    <mat-autocomplete
      #customerAuto="matAutocomplete"
      [displayWith]="displayCustomer"
      (optionSelected)="onCustomerSelected($event.option.value)"
    >
      <mat-option *ngFor="let option of customerOptions$ | async" [value]="option">
        {{ option.label }}
      </mat-option>
    </mat-autocomplete>
  </div>

  <!-- Groups, multiple: `group_ids` is a Many2many and has been since the
       model was written. The screen simply never offered it. -->
  <div class="audience-scope__field" *ngIf="isGroup">
    <label class="audience-scope__label">
      {{ "knowledge_base.upload.select_group" | translate }}
    </label>
    <mat-chip-list #groupChipList>
      <mat-chip
        *ngFor="let group of selectedGroups"
        [removable]="true"
        (removed)="removeGroup(group)"
        class="audience-scope__chip"
      >
        {{ group.name }}
        <ui-svg-icon svgIcon="close-cc" size="small" matChipRemove></ui-svg-icon>
      </mat-chip>
      <input
        *ngIf="!allGroupsPicked"
        [placeholder]="'knowledge_base.upload.select_group_placeholder' | translate"
        [formControl]="groupControl"
        [matAutocomplete]="groupAuto"
        [matChipInputFor]="groupChipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="false"
      />
    </mat-chip-list>
    <mat-autocomplete #groupAuto="matAutocomplete" (optionSelected)="addGroup($event.option.value)">
      <mat-option *ngFor="let group of filteredGroups$ | async" [value]="group">
        {{ group.name }}
      </mat-option>
    </mat-autocomplete>
  </div>
</div>
